<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <modal :state="state" backdrop hideable @hide="cancel">
    <template #title>
      {{ attachment.exists ? $t('title.replace') : $t('title.upload') }}
    </template>
    <template #body>
      <div class="modal-introduction">
        <i18n tag="p" path="introduction[0]">
          <template #filename>
            <strong>{{ file.name }}</strong>
          </template>
          <template #attachmentName>
            <strong>{{ attachment.name }}</strong>
          </template>
        </i18n>
        <p>{{ $t('introduction[1]') }}</p>
      </div>
      <div class="modal-actions">
        <button class="btn btn-primary" type="button" @click="confirm">
          {{ $t('action.yesProceed') }}
        </button>
        <button class="btn btn-link" type="button" @click="cancel">
          {{ $t('action.noCancel') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../modal.vue';

export default {
  name: 'FormAttachmentNameMismatch',
  components: { Modal },
  props: {
    state: {
      type: Boolean,
      default: false
    },
    plannedUploads: {
      type: Array,
      required: true
    }
  },
  computed: {
    // Returning dummy values for `attachment` and `file` when
    // plannedUploads.length !== 1 in order to simplify the template.
    attachment() {
      return this.plannedUploads.length === 1
        ? this.plannedUploads[0].attachment
        : { name: '', exists: false };
    },
    file() {
      return this.plannedUploads.length === 1
        ? this.plannedUploads[0].file
        : { name: '' };
    }
  },
  methods: {
    confirm() {
      this.$emit('hide');
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('hide');
      this.$emit('cancel');
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is the title at the top of a pop-up.
    "title": {
      "upload": "Upload File",
      "replace": "Replace File"
    },
    "introduction": [
      // {filename} and {attachmentName} are formatted in bold.
      "Are you sure you want to upload {filename} as {attachmentName}?",
      "We are double-checking because the filenames do not match."
    ]
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": {
      "upload": "Nahrát soubor",
      "replace": "Nahradit soubor"
    },
    "introduction": [
      "Opravdu chcete nahrát {filename} jako {attachmentName}?",
      "Dvakrát to kontrolujeme, protože názvy souborů se neshodují."
    ]
  },
  "de": {
    "title": {
      "upload": "Datei hochladen",
      "replace": "Datei ersetzen"
    },
    "introduction": [
      "Sind Sie sicher, dass Sie {filename} als {attachmentName} hochladen wollen?",
      "Wir fragen zurück, weil die Dateinamen nicht übereinstimmen."
    ]
  },
  "es": {
    "title": {
      "upload": "Subir archivo",
      "replace": "Reemplazar el archivo"
    },
    "introduction": [
      "Está seguro que quiere subir {filename} como {attachmentName}?",
      "Estamos verificando dos veces porque los nombres de los archivos no coinciden."
    ]
  },
  "fr": {
    "title": {
      "upload": "Téléverser un fichier",
      "replace": "Remplacer un fichier"
    },
    "introduction": [
      "Êtes-vous sûr de vouloir téléverser {filename} en tant que {attachmentName} ?",
      "Nous faisons une double vérification car les noms de fichiers ne correspondent pas."
    ]
  }
}
</i18n>
